import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { NAV } from "@/config/nav";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";

export function Sidebar({ open, onClose }) {
  const { can } = useAuth();
  const location = useLocation();
  const items = NAV.filter((n) => can(n.perm));

  useEffect(() => { onClose?.(); }, [location.pathname]); // eslint-disable-line

  return (
    <>
      {open && <div className="fixed inset-0 z-30 bg-black/50 lg:hidden" onClick={onClose} />}
      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-40 flex w-[250px] flex-col bg-sidebar text-white transition-transform duration-200 lg:translate-x-0",
          open ? "translate-x-0" : "-translate-x-full"
        )}
        data-testid="sidebar"
      >
        <div className="flex h-16 items-center justify-between border-b border-white/10 px-5">
          <div className="flex items-center gap-2.5">
            <img src="/icons/icon-96.png" alt="Hunter" className="h-8 w-8 rounded-sm" />
            <div className="leading-none">
              <div className="font-display text-lg font-bold tracking-tight">Hunter</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-white/40">Chain OS</div>
            </div>
          </div>
          <button className="lg:hidden" onClick={onClose}><X className="h-5 w-5" /></button>
        </div>
        <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-4">
          {items.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.slice(1)}`}
              className={({ isActive }) =>
                cn(
                  "group flex items-center gap-3 rounded-sm px-3 py-2 text-sm font-medium transition-colors",
                  isActive ? "bg-primary text-white" : "text-white/60 hover:bg-white/10 hover:text-white"
                )
              }
            >
              <n.icon className="h-[18px] w-[18px] shrink-0" strokeWidth={2} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 px-5 py-3 text-[11px] text-white/30">Hunter v1.0 · Phase 1</div>
      </aside>
    </>
  );
}
